import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=53843180&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&id=53843180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53843180",
  null
  
)

export default component.exports